import React, { useEffect, useState } from "react";
import { getPlans, createCheckout } from "../lib/api";
import { toast } from "sonner";
import { Check, Lock, Newspaper } from "lucide-react";

export default function Subscribe() {
  const [plans, setPlans] = useState([]);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    getPlans().then(setPlans).catch(() => {});
  }, []);

  const subscribe = async (lookupKey) => {
    setBusy(lookupKey);
    try {
      const { checkout_url } = await createCheckout(lookupKey);
      if (checkout_url) window.location.href = checkout_url;
      else throw new Error();
    } catch {
      toast.error("Could not start checkout. Please try again.");
      setBusy(null);
    }
  };

  return (
    <div className="paper-texture min-h-screen">
      <div className="border-b border-[var(--paper-border)] bg-[var(--navy)]">
        <div className="mx-auto max-w-3xl px-4 py-14 text-center">
          <p className="eyebrow flex items-center justify-center gap-2 text-[var(--gold)]"><Newspaper size={14} /> Digital Subscription</p>
          <h1 className="font-display text-4xl font-extrabold text-white sm:text-5xl">Read without limits</h1>
          <p className="font-serif-body mx-auto mt-3 max-w-xl text-lg text-white/80">
            The News-Leader is free for everyone — enjoy 3 premium articles each month on us. Subscribe to unlock every story and support local journalism in Nassau County.
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-4xl px-4 py-14">
        <div className="grid gap-6 sm:grid-cols-2">
          {plans.map((p) => (
            <div
              key={p.lookup_key}
              data-testid={`plan-${p.lookup_key}`}
              className={`relative flex flex-col rounded-2xl border bg-white p-8 ${
                p.best_value ? "border-[var(--gold)] ring-2 ring-[var(--gold)]/40 shadow-xl" : "border-[var(--paper-border)]"
              }`}
            >
              {p.best_value && (
                <span className="eyebrow absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-[var(--gold)] px-3 py-1 text-[10px] text-white">
                  Best Value
                </span>
              )}
              <h3 className="font-display text-2xl font-bold text-[var(--navy)]">{p.name}</h3>
              <div className="mt-3 flex items-end gap-1">
                <span className="font-display text-5xl font-extrabold text-[var(--ink)]">{p.price}</span>
                <span className="font-ui mb-1 text-sm text-slate-500">/{p.interval}</span>
              </div>
              <ul className="mt-6 flex-1 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="font-serif-body flex items-start gap-2 text-slate-700">
                    <Check size={18} className="mt-0.5 shrink-0 text-[var(--gold)]" /> {f}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => subscribe(p.lookup_key)}
                disabled={busy === p.lookup_key}
                data-testid={`subscribe-${p.lookup_key}`}
                className={`font-ui mt-8 rounded-full px-6 py-3 text-xs font-semibold uppercase tracking-wider text-white transition-colors disabled:opacity-60 ${
                  p.best_value ? "bg-[var(--gold)] hover:bg-[#b08f48]" : "bg-[var(--navy)] hover:bg-[var(--header-navy)]"
                }`}
              >
                {busy === p.lookup_key ? "Redirecting…" : `Subscribe ${p.price}/${p.interval}`}
              </button>
            </div>
          ))}
        </div>

        <p className="font-ui mt-8 flex items-center justify-center gap-2 text-center text-xs text-slate-500">
          <Lock size={13} /> Secure checkout by Stripe · Cancel anytime · Test card 4242 4242 4242 4242
        </p>
      </div>
    </div>
  );
}
